var map = {
	"./": 458,
	"./development": 1409,
	"./development.js": 1409,
	"./index": 458,
	"./index.js": 458,
	"./preprod": 1410,
	"./preprod.js": 1410,
	"./production": 1390,
	"./production.js": 1390,
	"./staging": 1411,
	"./staging.js": 1411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3369;